import { LayaGL } from "../../../layagl/LayaGL";
import { ShaderDataType } from "../../../RenderDriver/DriverDesign/RenderDevice/ShaderData";
import { BufferUsage } from "../../../RenderEngine/RenderEnum/BufferTargetType";
import { Shader3D, ShaderFeatureType } from "../../../RenderEngine/RenderShader/Shader3D";
import { SubShader } from "../../../RenderEngine/RenderShader/SubShader";
import { VertexDeclaration } from "../../../RenderEngine/VertexDeclaration";
import { VertexElement } from "../../../renders/VertexElement";
import { VertexElementFormat } from "../../../renders/VertexElementFormat";
import SequenceFrame2DFS from "./shader/SequenceFrame2D.fs";
import SequenceFrame2DVS from "./shader/SequenceFrame2D.vs";
export var SequenceFrame2DVertex;
(function (SequenceFrame2DVertex) {
    SequenceFrame2DVertex[SequenceFrame2DVertex["PositionUV"] = 0] = "PositionUV";
    SequenceFrame2DVertex[SequenceFrame2DVertex["Matrix0"] = 1] = "Matrix0";
    SequenceFrame2DVertex[SequenceFrame2DVertex["Matrix1"] = 2] = "Matrix1";
    SequenceFrame2DVertex[SequenceFrame2DVertex["Runtime"] = 3] = "Runtime";
    SequenceFrame2DVertex[SequenceFrame2DVertex["Playback"] = 4] = "Playback";
    SequenceFrame2DVertex[SequenceFrame2DVertex["SizeTiles"] = 5] = "SizeTiles";
    SequenceFrame2DVertex[SequenceFrame2DVertex["ColorUnit"] = 6] = "ColorUnit";
    SequenceFrame2DVertex[SequenceFrame2DVertex["UVRect"] = 7] = "UVRect";
})(SequenceFrame2DVertex || (SequenceFrame2DVertex = {}));
export class SequenceFrame2DShader {
    static __init__() {
        if (SequenceFrame2DShader._inited) {
            return;
        }
        SequenceFrame2DShader._inited = true;
        const attributeMap = {
            "a_SequenceFramePositionUV": [SequenceFrame2DVertex.PositionUV, ShaderDataType.Vector4],
            "a_SequenceFrameMatrix0": [SequenceFrame2DVertex.Matrix0, ShaderDataType.Vector4],
            "a_SequenceFrameMatrix1": [SequenceFrame2DVertex.Matrix1, ShaderDataType.Vector4],
            "a_SequenceFrameRuntime": [SequenceFrame2DVertex.Runtime, ShaderDataType.Vector4],
            "a_SequenceFramePlayback": [SequenceFrame2DVertex.Playback, ShaderDataType.Vector4],
            "a_SequenceFrameSizeTiles": [SequenceFrame2DVertex.SizeTiles, ShaderDataType.Vector4],
            "a_SequenceFrameColorUnit": [SequenceFrame2DVertex.ColorUnit, ShaderDataType.Vector4],
            "a_SequenceFrameUVRect": [SequenceFrame2DVertex.UVRect, ShaderDataType.Vector4],
        };
        const uniformMap = {};
        const shader = Shader3D.add("SequenceFrame2D", true, false);
        shader.shaderType = ShaderFeatureType.Default;
        const subShader = new SubShader(attributeMap, uniformMap, {});
        shader.addSubShader(subShader);
        subShader.addShaderPass(SequenceFrame2DVS, SequenceFrame2DFS);
        SequenceFrame2DShader.baseDeclaration = new VertexDeclaration(16, [
            new VertexElement(0, VertexElementFormat.Vector4, SequenceFrame2DVertex.PositionUV),
        ]);
        SequenceFrame2DShader.runtimeDeclaration = new VertexDeclaration(SequenceFrame2DShader.RUNTIME_FLOAT_STRIDE * 4, [
            new VertexElement(0, VertexElementFormat.Vector4, SequenceFrame2DVertex.Matrix0),
            new VertexElement(16, VertexElementFormat.Vector4, SequenceFrame2DVertex.Matrix1),
            new VertexElement(32, VertexElementFormat.Vector4, SequenceFrame2DVertex.Runtime),
        ]);
        SequenceFrame2DShader.configDeclaration = new VertexDeclaration(SequenceFrame2DShader.CONFIG_FLOAT_STRIDE * 4, [
            new VertexElement(0, VertexElementFormat.Vector4, SequenceFrame2DVertex.Playback),
            new VertexElement(16, VertexElementFormat.Vector4, SequenceFrame2DVertex.SizeTiles),
            new VertexElement(32, VertexElementFormat.Vector4, SequenceFrame2DVertex.ColorUnit),
            new VertexElement(48, VertexElementFormat.Vector4, SequenceFrame2DVertex.UVRect),
        ]);
        const vertexData = new Float32Array([
            -0.5, -0.5, 0, 0,
            0.5, -0.5, 1, 0,
            0.5, 0.5, 1, 1,
            -0.5, 0.5, 0, 1,
        ]);
        const indexData = new Uint16Array([0, 1, 2, 0, 2, 3]);
        const vertexBuffer = SequenceFrame2DShader._vbs = LayaGL.renderDeviceFactory.createVertexBuffer(BufferUsage.Static);
        vertexBuffer.vertexDeclaration = SequenceFrame2DShader.baseDeclaration;
        vertexBuffer.instanceBuffer = false;
        vertexBuffer.setDataLength(vertexData.byteLength);
        vertexBuffer.setData(vertexData.buffer, 0, 0, vertexData.byteLength);
        const indexBuffer = SequenceFrame2DShader._ibs = LayaGL.renderDeviceFactory.createIndexBuffer(BufferUsage.Static);
        indexBuffer._setIndexDataLength(indexData.byteLength);
        indexBuffer._setIndexData(indexData, 0);
    }
}
SequenceFrame2DShader.RUNTIME_FLOAT_STRIDE = 12;
SequenceFrame2DShader.CONFIG_FLOAT_STRIDE = 16;
SequenceFrame2DShader.INSTANCE_FLOAT_STRIDE = SequenceFrame2DShader.RUNTIME_FLOAT_STRIDE + SequenceFrame2DShader.CONFIG_FLOAT_STRIDE;
SequenceFrame2DShader._inited = false;
